import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/group-young-people-working-together-project_23-2148461544.jpg';

function SNAP() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Supplemental Nutrition Assistance Program" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Supplemental Nutrition Assistance Program (SNAP)</h4>
              <p>
                SNAP, formerly known as the Food Stamp Program, is the nation's most important anti-hunger program. 
                SNAP provides nutritional support for low-income seniors, people with disabilities living on fixed incomes, 
                and other individuals and families who are working toward self-sufficiency.
              </p>
              <p>
                The State of GTS is committed to helping eligible residents access SNAP benefits to ensure they have 
                access to healthy, nutritious food. Our program helps reduce food insecurity and improve the health 
                and well-being of families and individuals throughout our state.
              </p>
              <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <a
                  href="/new_pdfs_to_load/StateofGTS-ffy25-SNAP-FAQ%202.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  SNAP Frequently Asked Questions (PDF)
                </a>
                <a
                  href="/snap-documents/SNAP_FactSheets_022525_FL10.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  SNAP Fact Sheets (PDF)
                </a>
                <a
                  href="/new_pdfs_to_load/EN-05-10101v2%201.pdf"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    fontSize: '14px',
                    color: '#e75934',
                    textDecoration: 'none',
                    border: '1px solid #e75934',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    backgroundColor: 'transparent',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e75934';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.color = '#e75934';
                  }}
                >
                  <i className="fa-solid fa-file-pdf" style={{ marginRight: '8px', fontSize: '14px' }} />
                  SNAP Information Guide (PDF)
                </a>
              </div>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Information</h3>
              <div style={{ marginTop: '20px' }}>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Eligibility Requirements</h5>
                  <p style={{ color: '#666', marginBottom: '8px' }}>SNAP eligibility is based on household income, resources, and other factors. Learn more about eligibility requirements and how to apply.</p>
                  <Link to="/department/family-services/snap/snap-eligibility" style={{ color: '#e75934', textDecoration: 'none', fontWeight: '500' }}>
                    View Eligibility Requirements <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px' }} />
                  </Link>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Electronic Benefits Transfer (EBT)</h5>
                  <p style={{ color: '#666', marginBottom: '8px' }}>SNAP benefits are provided through an EBT card that works like a debit card. Learn how to use your EBT card and where you can shop.</p>
                  <Link to="/department/family-services/snap/ebt" style={{ color: '#e75934', textDecoration: 'none', fontWeight: '500' }}>
                    Learn About EBT <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px' }} />
                  </Link>
                </div>
                <div style={{ marginBottom: '0' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: '600' }}>Work Requirements</h5>
                  <p style={{ color: '#666', marginBottom: '8px' }}>Some SNAP recipients may be subject to work requirements. Learn about Able-Bodied Adults Without Dependents (ABAWD) and mandatory work participants.</p>
                  <Link to="/department/family-services/snap/abawd" style={{ color: '#e75934', textDecoration: 'none', fontWeight: '500' }}>
                    View Work Requirements <i className="fa-solid fa-arrow-right" style={{ marginLeft: '5px' }} />
                  </Link>
                </div>
              </div>
            </div>

            <div className="department-details-box">
              <div className="department-details-policy">
                <span>
                  Access to nutritious food is a fundamental right.
                </span>
              </div>
              <p>
                The State of GTS is dedicated to ensuring that all eligible residents have access to SNAP benefits. 
                Our program is designed to be accessible, efficient, and supportive of families working toward self-sufficiency.
              </p>
            </div>

            <div className="department-details-benefits-inner-box">
              <h3>How to Apply</h3>
              <p>
                You can apply for SNAP benefits online, by mail, or in person at your local Department of Family and Children Services office. 
                The application process is designed to be straightforward and accessible.
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>Online:</strong> Apply through our secure online portal
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>By Mail:</strong> Download and complete the application form, then mail it to your local office
                </li>
                <li>
                  <i className="fa-solid fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }} />
                  <strong>In Person:</strong> Visit your local Department of Family and Children Services office
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>What Can You Buy with SNAP Benefits?</h4>
              <p>
                SNAP benefits can be used to purchase a variety of food items including:
              </p>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Fruits and vegetables
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Meat, poultry, and fish
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Dairy products
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Breads and cereals
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Snack foods and non-alcoholic beverages
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '12px' }} />
                  Seeds and plants that produce food
                </li>
              </ul>
              <p style={{ marginTop: '15px' }}>
                <strong>Note:</strong> SNAP benefits cannot be used to purchase alcohol, tobacco, vitamins, medicines, 
                hot foods prepared for immediate consumption, or non-food items.
              </p>
            </div>

            <div className="department-details-policy-box">
              <h4>Online Grocery Purchasing</h4>
              <p>
                SNAP recipients can now use their EBT cards to purchase groceries online from participating retailers. 
                This service provides greater convenience and access to food, especially for those who may have difficulty 
                visiting physical stores.
              </p>
              <p>
                To determine if grocery delivery is available for your location, please visit the retailers' websites. 
                Please note that EBT cards can only be used for approved grocery items and cannot be used for delivery fees.
              </p>
            </div>

            <div>
              <Link to="/department/family-services">
              <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }}/>
              Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SNAP;

